import CloseAllPositionsModal from 'src/components/Modals/CloseAllPositionsModal';
import ClosePositionModal from 'src/components/Modals/ClosePositionModal/ClosePositionModal';
import EditOrderModal from 'src/components/Modals/EditOrderModal/EditOrderModal';
import FeeTierModal from 'src/components/Modals/FeeTierModal/FeeTierModal';
import useModal from 'src/components/Modals/hooks/useModal';
import PnlModal from 'src/components/Modals/PnlModal/PnlModal';
import TpSlOrderFormModal from 'src/components/Modals/TpSlOrderFormModal';
import TpSlTriggerPercentBasisModal from 'src/components/Modals/TpSlTriggerPercentBasisModal/TpSlTriggerPercentBasisModal';
import SwapConfirmationModal from 'src/components/SwapConfirmationModal';
import { TradeConfirmationModal } from 'src/components/TradeConfirmationModal';
import MarginModeModal from '../MarginModeModal';
import PositionMaxLeverageModal from '../PositionMaxLeverageModal';
import IsolatedPositionMarginModal from '../PerpIsolatedPositionMarginModal';

export default function TradingModals() {
	const { currentModal } = useModal();

	return (
		<>
			{currentModal?.type === 'trade_confirmation' && (
				<TradeConfirmationModal {...currentModal.props} />
			)}
			{currentModal?.type === 'swap_confirmation' && <SwapConfirmationModal />}

			{currentModal?.type === 'edit_order' && (
				<EditOrderModal {...currentModal.props} />
			)}
			{currentModal?.type === 'tp_sl' && (
				<TpSlOrderFormModal {...currentModal.props} />
			)}
			{currentModal?.type === 'tp_sl_trigger_percent_basis' && (
				<TpSlTriggerPercentBasisModal />
			)}

			{currentModal?.type === 'close_position' && (
				<ClosePositionModal {...currentModal.props} />
			)}
			{currentModal?.type === 'close_all_positions' && (
				<CloseAllPositionsModal {...currentModal.props} />
			)}

			{currentModal?.type === 'pnl_card' && (
				<PnlModal {...currentModal.props} />
			)}

			{currentModal?.type === 'fee_tier' && <FeeTierModal />}

			{currentModal?.type === 'position_max_leverage' && (
				<PositionMaxLeverageModal {...currentModal.props} />
			)}
			{currentModal?.type === 'margin_mode' && <MarginModeModal />}
			{currentModal?.type === 'isolated_position_margin' && (
				<IsolatedPositionMarginModal {...currentModal.props} />
			)}
		</>
	);
}
